import { useState, useEffect } from 'react';
import { subscribeWishlist, addWish, updateWish, deleteWish, wishToBD } from '../utils/firestoreService';
import { useAuth } from '../hooks/useAuth';
import { GENRES, EDITEURS } from '../utils/constants';
import Mascot from './Mascot';
import { genreColor } from '../utils/genreColors';

const F = "'Inter',-apple-system,sans-serif";
const D = "'Bangers','Arial Black',cursive";

const PRIO = [
  { v: 'haute',   label: 'Haute',   color: '#DC2626', bg: '#FEF2F2', border: '#FECACA' },
  { v: 'moyenne', label: 'Moyenne', color: '#D97706', bg: '#FFFBEB', border: '#FDE68A' },
  { v: 'basse',   label: 'Basse',   color: 'var(--muted)', bg: 'var(--surface2)', border: 'var(--border)' },
];
const getPrio = v => PRIO.find(p => p.v === v) || PRIO[1];

/* ── Formulaire ajout souhait ─────────────────────────────── */
function WishForm({ wish, onSave, onClose }) {
  const [form, setForm] = useState({
    serie: '', numero: '', titre: '', auteur: '',
    editeur: '', genre: '', priorite: 'moyenne', notes: '',
    ...wish,
  });
  const set = (k, v) => setForm(p => ({ ...p, [k]: v }));

  const S = {
    overlay: { position:'fixed',inset:0,background:'rgba(28,22,18,.65)',backdropFilter:'blur(6px)',display:'flex',alignItems:'flex-end',justifyContent:'center',zIndex:1200 },
    sheet: { background:'var(--bg)',borderRadius:'22px 22px 0 0',border:'1px solid var(--border)',borderBottom:'none',width:'100%',maxWidth:'520px',maxHeight:'90vh',overflowY:'auto',animation:'slideUp .3s cubic-bezier(.22,1,.36,1)',fontFamily:F },
    header: { padding:'1rem 1.25rem',borderBottom:'1px solid var(--border)',display:'flex',alignItems:'center',justifyContent:'space-between',position:'sticky',top:0,background:'var(--header-bg)',backdropFilter:'blur(10px)',borderRadius:'22px 22px 0 0' },
    body: { padding:'1.25rem' },
    label: { display:'block',fontSize:'11px',fontWeight:600,color:'var(--muted)',marginBottom:'5px',textTransform:'uppercase',letterSpacing:'.05em' },
    input: { width:'100%',padding:'10px 12px',border:'1.5px solid var(--border)',borderRadius:'9px',fontFamily:F,fontSize:'14px',color:'var(--ink)',background:'var(--surface)',outline:'none',transition:'border-color .15s, box-shadow .15s' },
    grid2: { display:'grid',gridTemplateColumns:'minmax(0,1fr) minmax(0,1fr)',gap:'10px',marginBottom:'12px' },
    footer: { padding:'1rem 1.25rem',borderTop:'1px solid var(--border)',display:'flex',gap:'10px',justifyContent:'flex-end',position:'sticky',bottom:0,background:'var(--header-bg)',backdropFilter:'blur(10px)' },
  };
  const onFocus = e => { e.target.style.borderColor='var(--orange)'; e.target.style.boxShadow='0 0 0 3px rgba(240,78,26,.10)'; };
  const onBlur  = e => { e.target.style.borderColor='var(--border)'; e.target.style.boxShadow='none'; };

  return (
    <div style={S.overlay} onClick={e=>e.target===e.currentTarget&&onClose()}>
      <div style={S.sheet}>
        <div style={S.header}>
          <div style={{fontFamily:D,fontSize:'1.3rem',letterSpacing:'.05em',color:'var(--orange)'}}>{wish?.id ? '✏️ Modifier' : '✨ Ajouter un souhait'}</div>
          <button onClick={onClose} style={{width:'30px',height:'30px',borderRadius:'50%',border:'1px solid var(--border)',background:'var(--surface2)',cursor:'pointer',fontSize:'16px',color:'var(--muted)',display:'flex',alignItems:'center',justifyContent:'center',padding:0}}>×</button>
        </div>
        <div style={S.body}>
          <div style={S.grid2}>
            <div><label style={S.label}>Série</label><input style={S.input} value={form.serie} onChange={e=>set('serie',e.target.value)} placeholder="Naruto, One Piece…" onFocus={onFocus} onBlur={onBlur}/></div>
            <div><label style={S.label}>Tome</label><input style={S.input} type="number" value={form.numero} onChange={e=>set('numero',e.target.value)} placeholder="12" min="0" onFocus={onFocus} onBlur={onBlur}/></div>
          </div>
          <div style={{marginBottom:'12px'}}><label style={S.label}>Titre</label><input style={S.input} value={form.titre} onChange={e=>set('titre',e.target.value)} placeholder="Titre de l'album" onFocus={onFocus} onBlur={onBlur}/></div>
          <div style={S.grid2}>
            <div><label style={S.label}>Auteur</label><input style={S.input} value={form.auteur} onChange={e=>set('auteur',e.target.value)} placeholder="Auteur" onFocus={onFocus} onBlur={onBlur}/></div>
            <div><label style={S.label}>Éditeur</label>
              <select style={{...S.input,cursor:'pointer'}} value={form.editeur} onChange={e=>set('editeur',e.target.value)}>
                <option value="">— Choisir —</option>
                {EDITEURS.map(e=><option key={e} value={e}>{e}</option>)}
              </select>
            </div>
          </div>
          <div style={{marginBottom:'12px'}}><label style={S.label}>Genre</label>
            <select style={{...S.input,cursor:'pointer'}} value={form.genre} onChange={e=>set('genre',e.target.value)}>
              <option value="">— Genre —</option>
              {GENRES.map(g=><option key={g} value={g}>{g}</option>)}
            </select>
          </div>
          {/* Priorité */}
          <div style={{marginBottom:'12px'}}>
            <label style={S.label}>Priorité</label>
            <div style={{display:'flex',gap:'8px'}}>
              {PRIO.map(p=>(
                <button key={p.v} type="button" onClick={()=>set('priorite',p.v)}
                  style={{flex:1,padding:'9px',border:`1.5px solid ${form.priorite===p.v?p.color:p.border}`,borderRadius:'10px',background:form.priorite===p.v?p.bg:'#fff',color:form.priorite===p.v?p.color:'var(--muted)',fontFamily:F,fontSize:'13px',fontWeight:form.priorite===p.v?700:500,cursor:'pointer',transition:'all .15s'}}>
                  {p.label}
                </button>
              ))}
            </div>
          </div>
          <div><label style={S.label}>Notes</label>
            <textarea style={{...S.input,resize:'vertical',minHeight:'70px',lineHeight:1.5}} value={form.notes} onChange={e=>set('notes',e.target.value)} placeholder="Édition souhaitée, prix max, occasion particulière…" onFocus={onFocus} onBlur={onBlur}/>
          </div>
        </div>
        <div style={S.footer}>
          <button onClick={onClose} style={{padding:'10px 20px',border:'1.5px solid var(--border)',borderRadius:'99px',background:'var(--surface)',fontFamily:F,fontSize:'14px',fontWeight:600,color:'var(--muted)',cursor:'pointer'}}>Annuler</button>
          <button onClick={()=>onSave(form)} style={{padding:'10px 24px',border:'none',borderRadius:'99px',background:'var(--orange)',color:'#fff',fontFamily:F,fontSize:'14px',fontWeight:700,cursor:'pointer',boxShadow:'0 3px 12px rgba(240,78,26,.3)',transition:'transform .15s, box-shadow .15s'}}
            onMouseOver={e=>{e.currentTarget.style.transform='translateY(-1px)';e.currentTarget.style.boxShadow='0 6px 18px rgba(240,78,26,.38)';}}
            onMouseOut={e=>{e.currentTarget.style.transform='none';e.currentTarget.style.boxShadow='0 3px 12px rgba(240,78,26,.3)';}}>
            {wish?.id ? 'Enregistrer' : 'Ajouter à la liste'}
          </button>
        </div>
      </div>
      <style>{`@keyframes slideUp{from{opacity:0;transform:translateY(40px)}to{opacity:1;transform:translateY(0)}}`}</style>
    </div>
  );
}

/* ── Carte souhait ────────────────────────────────────────── */
function WishCard({ wish, onEdit, onDelete, onAcquired }) {
  const prio = getPrio(wish.priorite);
  return (
    <div style={{background:'var(--surface)',border:`1px solid var(--border)`,borderRadius:'14px',padding:'14px',boxShadow:'0 1px 4px rgba(0,0,0,.05)',transition:'transform .2s, box-shadow .2s'}}
      onMouseOver={e=>{e.currentTarget.style.transform='translateY(-2px)';e.currentTarget.style.boxShadow='0 6px 18px rgba(0,0,0,.09)';}}
      onMouseOut={e=>{e.currentTarget.style.transform='none';e.currentTarget.style.boxShadow='0 1px 4px rgba(0,0,0,.05)';}}>

      <div style={{display:'flex',alignItems:'flex-start',justifyContent:'space-between',gap:'8px',marginBottom:'8px'}}>
        <div style={{flex:1,minWidth:0}}>
          {wish.serie && <div style={{fontSize:'10px',fontWeight:700,color:'var(--orange)',textTransform:'uppercase',letterSpacing:'.07em',marginBottom:'2px'}}>{wish.serie}{wish.numero?` · T.${wish.numero}`:''}</div>}
          <div style={{fontSize:'14px',fontWeight:700,color:'var(--ink)',lineHeight:1.3}}>{wish.titre || wish.serie || '(Sans titre)'}</div>
          {wish.auteur && <div style={{fontSize:'12px',color:'var(--muted)',marginTop:'2px'}}>{wish.auteur}</div>}
        </div>
        <div style={{background:prio.bg,color:prio.color,border:`1px solid ${prio.border}`,borderRadius:'99px',padding:'3px 9px',fontSize:'11px',fontWeight:700,fontFamily:F,flexShrink:0}}>
          {prio.label}
        </div>
      </div>

      <div style={{display:'flex',flexWrap:'wrap',gap:'4px',marginBottom:'10px'}}>
        {wish.editeur && <Chip label={wish.editeur}/>}
        {wish.genre   && <Chip label={wish.genre} dotColor={genreColor(wish.genre)}/>}
      </div>
      {wish.notes && <div style={{fontSize:'12px',color:'var(--muted)',fontStyle:'italic',marginBottom:'10px',lineHeight:1.5}}>"{wish.notes}"</div>}

      <div style={{display:'flex',gap:'7px'}}>
        <button onClick={()=>onAcquired(wish)}
          style={{flex:1,padding:'8px',border:'none',borderRadius:'8px',background:'#F0FDF4',color:'#15803D',fontFamily:F,fontSize:'13px',fontWeight:700,cursor:'pointer',transition:'background .15s'}}
          onMouseOver={e=>e.currentTarget.style.background='#DCFCE7'}
          onMouseOut={e=>e.currentTarget.style.background='#F0FDF4'}>
          ✓ Acquis !
        </button>
        <button onClick={()=>onEdit(wish)}
          style={{padding:'8px 12px',border:'1px solid var(--border)',borderRadius:'8px',background:'var(--surface)',fontFamily:F,fontSize:'13px',fontWeight:600,color:'var(--muted)',cursor:'pointer',transition:'all .15s'}}
          onMouseOver={e=>{e.currentTarget.style.borderColor='var(--orange)';e.currentTarget.style.color='var(--orange)';}}
          onMouseOut={e=>{e.currentTarget.style.borderColor='var(--border)';e.currentTarget.style.color='var(--muted)';}}>
          ✏️
        </button>
        <button onClick={()=>onDelete(wish)}
          style={{padding:'8px 12px',border:'1px solid #FECACA',borderRadius:'8px',background:'#FEF2F2',fontFamily:F,fontSize:'13px',fontWeight:600,color:'#DC2626',cursor:'pointer'}}
          onMouseOver={e=>e.currentTarget.style.background='#FEE2E2'}
          onMouseOut={e=>e.currentTarget.style.background='#FEF2F2'}>
          🗑
        </button>
      </div>
    </div>
  );
}

const Chip = ({label,orange,dotColor}) => (
  <span style={{fontSize:'11px',fontWeight:600,fontFamily:F,background:dotColor?`${dotColor}17`:(orange?'var(--orange-pale)':'var(--surface2)'),color:dotColor||(orange?'var(--orange-d)':'var(--muted)'),borderRadius:'4px',padding:'2px 7px',display:'inline-flex',alignItems:'center',gap:'4px'}}>
    {dotColor && <span style={{width:'6px',height:'6px',borderRadius:'50%',background:dotColor,flexShrink:0}}/>}
    {label}
  </span>
);

/* ── Vue principale wishlist ──────────────────────────────── */
export default function WishlistView({ onToast }) {
  const { user } = useAuth();
  const [wishes, setWishes]   = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setForm]   = useState(false);
  const [editWish, setEdit]   = useState(null);
  const [sortPrio, setSort]   = useState(true);

  useEffect(() => {
    const unsub = subscribeWishlist(
      user.uid,
      (data) => { setWishes(data); setLoading(false); },
      (err)  => { onToast('Erreur wishlist : '+err.message, 'error'); setLoading(false); }
    );
    return unsub;
  }, [user.uid, onToast]);

  const handleSave = async (data) => {
    try {
      if (editWish?.id) {
        await updateWish(user.uid, editWish.id, data);
        setWishes(p => p.map(w => w.id===editWish.id ? {...w,...data} : w));
        onToast('Souhait modifié ✓');
      } else {
        const id = await addWish(user.uid, data);
        setWishes(p => [{id,...data,createdAt:new Date()}, ...p]);
        onToast('Ajouté à ta liste de souhaits ✨');
      }
      setForm(false); setEdit(null);
    } catch(e) { onToast('Erreur : '+e.message,'error'); }
  };

  const handleDelete = async (wish) => {
    if (!window.confirm(`Supprimer "${wish.titre||wish.serie||'ce souhait'}" de ta liste ?`)) return;
    await deleteWish(user.uid, wish.id);
    setWishes(p => p.filter(w => w.id!==wish.id));
    onToast('Souhait supprimé.');
  };

  const handleAcquired = async (wish) => {
    try {
      await wishToBD(user.uid, wish);
      setWishes(p => p.filter(w => w.id!==wish.id));
      onToast('Félicitations ! Ajouté à ta collection 📚');
    } catch(e) { onToast('Erreur : '+e.message,'error'); }
  };

  const sorted = [...wishes].sort((a,b) => {
    if (!sortPrio) return 0;
    const order = {haute:0, moyenne:1, basse:2};
    return (order[a.priorite]??1)-(order[b.priorite]??1);
  });

  return (
    <div style={{fontFamily:F}}>
      {/* Header wishlist */}
      <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:'1rem',flexWrap:'wrap',gap:'8px'}}>
        <div>
          <div style={{fontFamily:D,fontSize:'1.4rem',letterSpacing:'.05em',color:'var(--orange)'}}>Ma liste de souhaits</div>
          <div style={{fontSize:'12px',color:'var(--muted)',marginTop:'1px'}}>
            {wishes.length} album{wishes.length!==1?'s':''} à trouver
          </div>
        </div>
        <div style={{display:'flex',gap:'8px',alignItems:'center'}}>
          <button onClick={()=>setSort(s=>!s)}
            style={{padding:'8px 12px',border:`1px solid ${sortPrio?'var(--orange)':'var(--border)'}`,borderRadius:'8px',background:sortPrio?'var(--orange-pale)':'#fff',color:sortPrio?'var(--orange)':'var(--muted)',fontFamily:F,fontSize:'12px',fontWeight:600,cursor:'pointer'}}>
            {sortPrio ? '↑ Par priorité' : 'Trier par priorité'}
          </button>
          <button onClick={()=>{setEdit(null);setForm(true);}}
            style={{display:'flex',alignItems:'center',gap:'5px',padding:'8px 16px',border:'none',borderRadius:'99px',background:'var(--orange)',color:'#fff',fontFamily:F,fontSize:'14px',fontWeight:600,cursor:'pointer',boxShadow:'0 3px 12px rgba(240,78,26,.3)'}}>
            + Ajouter
          </button>
        </div>
      </div>

      {loading ? (
        <div style={{textAlign:'center',padding:'3rem',color:'var(--muted)',fontSize:'14px'}}>Chargement…</div>
      ) : wishes.length === 0 ? (
        <div style={{textAlign:'center',padding:'4rem 2rem',background:'var(--surface)',border:'1px solid var(--border)',borderRadius:'16px'}}>
          <Mascot variant="sparkle" size={100}/>
          <div style={{fontFamily:D,fontSize:'1.6rem',color:'var(--orange)',letterSpacing:'.04em',marginBottom:'8px'}}>Ta liste est vide</div>
          <div style={{fontSize:'14px',color:'var(--muted)',marginBottom:'1.5rem'}}>Ajoute les albums que tu cherches pour ne rien oublier.</div>
          <button onClick={()=>{setEdit(null);setForm(true);}} style={{padding:'10px 22px',border:'none',borderRadius:'99px',background:'var(--orange)',color:'#fff',fontFamily:F,fontSize:'14px',fontWeight:600,cursor:'pointer',boxShadow:'0 3px 12px rgba(240,78,26,.28)'}}>
            + Ajouter mon premier souhait
          </button>
        </div>
      ) : (
        <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fill,minmax(260px,1fr))',gap:'12px'}}>
          {sorted.map(w => (
            <WishCard key={w.id} wish={w}
              onEdit={w=>{setEdit(w);setForm(true);}}
              onDelete={handleDelete}
              onAcquired={handleAcquired}/>
          ))}
        </div>
      )}

      {showForm && (
        <WishForm wish={editWish} onSave={handleSave} onClose={()=>{setForm(false);setEdit(null);}}/>
      )}
    </div>
  );
}
